// Main columns configuration
import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";
import moment from "moment";
export const financialDocumentationCols = (
  viewModal,
  updateModal,
  deleteRecord
) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    Asset: [
      {
        title: "Asset Type",
        dataIndex: "module",
        key: "assetType",
        render: (text) => text || "N/A",
      },
      {
        title: "Name of Asset",
        dataIndex: "Name of Asset",
        key: "assetsName",
        render: (text) => text || "N/A",
      },
      {
        title: "Account Type",
        dataIndex: "Account Type/Titled",
        key: "accountType",
        render: (text) => text || "N/A",
      },
      {
        title: "Monetary Value",
        dataIndex: "Monetary Value",
        key: "monetaryValue",
        render: (text) => text || "N/A",
      },
      actionColumn,
    ],
    Loans: [
      {
        title: "Name of Liability",
        dataIndex: "Nickname of Liabilities",
        render: (_, record) => {
          if (record["Nickname of Credit"]) return record["Nickname of Credit"];
          if (record["Nickname of Liabilities"]) return record["Nickname of Liabilities"];
          return "N/A";
        }
      },
      {
        title: "Owner",
        dataIndex: "Owner",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Financial Institution",
        dataIndex: "Name of Financial Institution",
        render: (_, record) => {
          if (record["Name of Financial Institution"]) return record["Name of Financial Institution"];
          if (record["Name of Issuer"]) return record["Name of Issuer"];
          return "N/A";
        }
      },
      {
        title: "Monthly Payment",
        dataIndex: "Monthly Payment",
        render: (record) =>
          record
            ? !isNaN(record)
              ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                `$${parseFloat(record)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              : "N/A"
            : "N/A",
      },

      {
        title: "Interest Rate(%APR)",
        dataIndex: "Interest Rate",
        render: (_, record) => {
          if (record["Interest Rate"]) return `${record["Interest Rate"] + "%"}`;
          if (record["Interest Rate (or APR%)"]) return `${record["Interest Rate (or APR%)"] + "%"}`;
          return "N/A";
        }
      },
      {
        title: "Maturity Date",
        dataIndex: "Maturity Date",
        render: (record) =>
          record ? moment(record).format("MM/DD/YYYY") : "N/A",
      },
      {
        title: "Loan Balance",
        dataIndex: "Loan Balance",
        render: (record, row) => {
          const value =
            (row && row["Loan Balance"]) || row["Initial Loan Amount"] || row["Credit Balance"];
          return value
            ? !isNaN(value)
              ? `${
                  "$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }`
              : "N/A"
            : "N/A";
        },
      },
      actionColumn,
    ],
    "Safe Deposit Box Information": [
      {
        title: "Bank",
        dataIndex: "Bank",
        key: "bank",
      },
      {
        title: "Box Number",
        dataIndex: "Box Number",
        key: "boxnumber",
      },
      {
        title: "Key Location",
        dataIndex: "Key Location",
        key: "databackupsystems",
      },
      actionColumn,
    ],
    Income: [
      {
        title: "Type of Income",
        dataIndex: "module",
        key: "module",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Income Name",
        dataIndex: "Income Name",
        key: "Income Name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Gross Amount",
        dataIndex: "Gross Monthly Wages",
        key: "Gross Monthly Wages",
        render: (record) =>
          record
            ? !isNaN(record)
              ? `$${parseFloat(record)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              : "N/A"
            : "N/A",
      },
      {
        title: "Active/Passive",
        dataIndex: "Passive or Active",
        key: "Passive or Active",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Frequency",
        dataIndex: "Frequency of Pay Periods",
        key: "Frequency of Pay Periods",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Tax Record": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "Document Name",
      },
      {
        title: "Year",
        dataIndex: "Year",
        key: "Year",
      },
      actionColumn,
    ],
  };
};
